export function parseJsonString(jsonString) {
    try {
        const parsedData = JSON.parse(jsonString);
        return parsedData;
    } catch (error) {
        console.error("Invalid JSON string", error);
        return null;
    }
} 